import { createRouter, createWebHistory } from 'vue-router'
import api from '../api/document'

const Login = () => import('../views/Login.vue')
const DocumentList = () => import('../views/DocumentList.vue')
const MobileQuery = () => import('../views/MobileQuery.vue')
const ChangePassword = () => import('../views/ChangePassword.vue')
const UserManagement = () => import('../views/UserManagement.vue')

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'DocumentList',
    component: DocumentList,
    meta: { requiresAuth: true }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: UserManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/mobile/query',
    name: 'MobileQuery',
    component: MobileQuery,
    meta: { requiresAuth: false }
  },
  {
    path: '/mobile/query/:reportNumber',
    name: 'MobileQueryWithParam',
    component: MobileQuery,
    props: true,
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

let authCheckPromise = null

async function verifyAuth() {
  const token = localStorage.getItem('token')
  if (!token) return false
  if (authCheckPromise) return authCheckPromise
  authCheckPromise = api.get('/auth/check').then(res => {
    return res.data.authenticated === true
  }).catch(() => {
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    localStorage.removeItem('isLoggedIn')
    return false
  }).finally(() => {
    authCheckPromise = null
  })
  return authCheckPromise
}

router.beforeEach(async (to, from, next) => {
  if (!to.meta.requiresAuth) {
    if (to.name === 'Login') {
      const token = localStorage.getItem('token')
      if (token) {
        try {
          const res = await api.get('/auth/check')
          if (res.data.authenticated) {
            next({ name: 'DocumentList' })
            return
          }
        } catch (e) {
          localStorage.removeItem('user')
          localStorage.removeItem('token')
          localStorage.removeItem('isLoggedIn')
        }
      }
    }
    next()
    return
  }
  const authenticated = await verifyAuth()
  if (!authenticated) {
    next({ name: 'Login' })
    return
  }
  // 强制改密：未改密前除 /change-password 外均拦截
  if (localStorage.getItem('mustChangePassword') === 'true' && to.name !== 'ChangePassword') {
    next({ name: 'ChangePassword' })
    return
  }
  // 角色守卫：仅管理员可访问的页面
  if (to.meta.requiresAdmin && localStorage.getItem('role') !== 'admin') {
    next({ name: 'DocumentList' })
    return
  }
  next()
})

export default router